<div class="pi-user-management-invitation-block">
    @if (isLoading) {
        <div class="load-container">
            <loading-dots></loading-dots>
        </div>
    }
    <div class="invitation-email__container">
        <div class="invitation-email__label">
            {{ TR.key('userManagement.emailInvitation.placeHolder') }}
        </div>
        <pi-user-typeahead
            #piUserTypeaheadInvitation
            class="invitation-email__input"
            [maxNumItems]="10"
            [disabled]="isLoading"
            [filterService]="sharedService"
        ></pi-user-typeahead>
    </div>
    <div class="invitation-access-level__container">
        <tapestry-select
            #piSelectRole
            class="invitation-access-level__select"
            [selectLabel]="TR.key('userManagement.sharing.permission')"
            [options]="piSelectOptions"
            [selected]="piSelectDefault"
            [disabled]="isLoading"
        ></tapestry-select>
    </div>
    <div class="invitation-invite-button__container">
        <button
            (click)="onInviteButtonClick()"
            class="button button-sm button-primary invitation-invite-button__btn"
            [disabled]="isLoading || !isReadyToInvite()"
        >
            {{ buttonMessage }}
        </button>
    </div>
</div>
@if (!!piUserTypeahead) {
    <div class="pi-user-management-notification-block">
        @if (piUserTypeahead?.chipList.errorState) {
            <div class="mat-errors">
                @for (
                    error of piUserTypeahead.errorStateMessages;
                    track error
                ) {
                    <mat-error>
                        {{ error }}
                    </mat-error>
                }
            </div>
        }
    </div>
}
